module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activityCompletion flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "activity flexcenter"
  }, [_c('div', {
    staticClass: "activityTitle"
  }, [_c('h3', [_vm._v("再チャレンジしますか？")])]), _vm._v(" "), _c('div', {
    staticClass: "activityContent"
  }, [_c('div', {
    staticClass: "activityScore flexcenter"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('ul', {
    staticClass: "score-list"
  }, [_c('li', {
    staticClass: "flexbetween"
  }, [_c('span', {
    staticClass: "ok align-left"
  }, [_vm._v("正解")]), _c('span', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.ok))])]), _vm._v(" "), _c('li', {
    staticClass: "flexbetween"
  }, [_c('span', {
    staticClass: "ng align-left"
  }, [_vm._v("不正解")]), _c('span', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.ng))])]), _vm._v(" "), _c('li', {
    staticClass: "flexbetween"
  }, [_c('span', {
    staticClass: "skip align-left"
  }, [_vm._v("スキップ")]), _c('span', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.skip))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "activityResetFooter"
  }, [_c('div', {
    staticClass: "buttons flexbetween"
  }, [_c('button', {
    staticClass: "home",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton('home')
      }
    }
  }, [_vm._v("ホーム")]), _vm._v(" "), _c('button', {
    staticClass: "continue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton('lessonScore')
      }
    }
  }, [_vm._v("他の問題を解く")]), _vm._v(" "), _c('button', {
    staticClass: "retry",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton('reset')
      }
    }
  }, [_vm._v("はい")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f8ce7f18", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-f8ce7f18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScoreReset.vue
// module id = 888
// module chunks = 1